// ============================================
// src/components/home/MethodologiesSection.tsx
// ============================================
"use client";
import { Box, Typography, Grid } from '@mui/material';
import { methodologiesData } from '@/data/methodologiesData';

interface MethodologiesSectionProps {
  isVisible: boolean;
}

export default function MethodologiesSection({ isVisible }: MethodologiesSectionProps) {
  return (
    <Grid container spacing={4}>
      {methodologiesData.map((methodology, index) => {
        const IconComponent = methodology.icon;
        const transitionDelay = 0.5 + index * 0.1;
        
        return (
          <Grid key={index} size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                p: 4,
                borderRadius: 3,
                border: `1px solid ${methodology.borderColor}`,
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
                transition: `all 1s cubic-bezier(0.4, 0, 0.2, 1) ${transitionDelay}s`,
                height: '100%',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                <IconComponent sx={{ fontSize: 32, color: methodology.iconColor }} />
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    color: 'white',
                  }}
                >
                  {methodology.title}
                </Typography>
              </Box>
              
              <Typography
                variant="body2"
                sx={{
                  color: 'rgba(255, 255, 255, 0.9)',
                  lineHeight: 1.7,
                  mb: methodology.items.length > 0 ? 3 : 0,
                }}
              >
                {methodology.description}
              </Typography>

              {methodology.items.length > 0 && (
                <Grid container spacing={2}>
                  {methodology.items.map((tech, techIndex) => (
                    <Grid key={techIndex} size={{ xs: 12 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Box
                          sx={{
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            bgcolor: methodology.iconColor,
                          }}
                        />
                        <Typography
                          variant="body2"
                          sx={{
                            color: 'rgba(255, 255, 255, 0.8)',
                            fontWeight: 500,
                          }}
                        >
                          {tech}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
}